import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col border-b-4 border-brand-dark-gray pb-2" }
const _hoisted_2 = { class: "flex justify-between p-4 pt-6" }
const _hoisted_3 = { class: "flex flex-col my-auto -space-y-0.5" }
const _hoisted_4 = { class: "flex space-x-2" }
const _hoisted_5 = { class: "text-white font-medium text-xl" }
const _hoisted_6 = { class: "flex space-x-2.5 text-brand-light-gray w-full" }
const _hoisted_7 = { class: "flex space-x-1" }
const _hoisted_8 = { class: "my-auto text-xs" }
const _hoisted_9 = { class: "text-xs my-auto" }
const _hoisted_10 = ["id"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "px-4 -mt-4 pb-4 text-brand-light-gray text-xxs my-auto"
}

import {computed, onMounted, PropType, ref} from "vue";
import ApiService from "@/services/api/apiService";
import {isPlatform, modalController, useIonRouter} from "@ionic/vue";
import UserVerificationCheck from "@/components/UserBadges.vue";
import * as sanitizeHtml from 'sanitize-html';
import UserAvatar from "@/components/UserAvatar.vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {ReviewInterface} from "@/interfaces/ReviewInterface";
import {DateTime} from "luxon";
import {Haptics, ImpactStyle} from "@capacitor/haptics";
import {useVerification} from "@/composables/useVerification";
import UserReviewContextMenu from "@/components/UserReviewContextMenu.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserReview',
  props: {
  review: {
    type: Object as PropType<ReviewInterface>,
    required: true
  }
},
  emits: ['onReply', 'tappedProfile'],
  setup(__props, { emit: __emit }) {


const props = __props

const authUser = ref()

const emit = __emit

const postedAt = computed(() => {
  return DateTime.fromISO(props.review.created_at).toRelative()
})

const showContext = async () => {

  const sheet = await modalController.create({
    breakpoints: [0, 1],
    initialBreakpoint: 1,
    component: UserReviewContextMenu,
    componentProps: {
      review: props.review
    },
    mode: 'ios'
  })
  await sheet.present()
}

const loading = ref(true)

const ionRouter = useIonRouter()

// Mounted
onMounted(async () => {
  authUser.value = await ApiService.User().authUser()
  loading.value = false
})

const viewProfile = async (user: UserBasicInformationInterface) => {
  if (isPlatform('capacitor')) await Haptics.impact({style: ImpactStyle.Light});
  ionRouter.navigate({
    name: 'PineappleUserProfile',
    params: {
      userId: user.id
    }
  }, 'forward', 'push')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.review.reviewer)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (viewProfile(__props.review.reviewer)), ["stop"])),
            class: "flex space-x-2"
          }, [
            _createVNode(UserAvatar, {
              user: __props.review.reviewer
            }, null, 8, ["user"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(__props.review.reviewer.name), 1),
                _createVNode(UserVerificationCheck, {
                  class: "h-4",
                  user: __props.review.reviewer
                }, null, 8, ["user"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                (__props.review.reviewer.location && false)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[1] || (_cache[1] = _createElementVNode("svg", {
                          class: "my-auto w-2.5 h-2.5 fill-current",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 384 512"
                        }, [
                          _createElementVNode("path", { d: "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(__props.review.reviewer.location.name), 1)
                      ]),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "my-auto" }, "•", -1))
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, _toDisplayString(postedAt.value), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (authUser.value && (authUser.value.id === __props.review.user_id || authUser.value.id === __props.review.reviewer.id))
        ? (_openBlock(), _createElementBlock("svg", {
            key: 1,
            onClick: showContext,
            class: "my-auto",
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("path", {
              d: "M5.52035 14.5583C6.71329 14.5583 7.68035 13.5912 7.68035 12.3983C7.68035 11.2053 6.71329 10.2383 5.52035 10.2383C4.32742 10.2383 3.36035 11.2053 3.36035 12.3983C3.36035 13.5912 4.32742 14.5583 5.52035 14.5583Z",
              fill: "#A5A7AF"
            }, null, -1),
            _createElementVNode("path", {
              d: "M12.0008 14.5583C13.1938 14.5583 14.1608 13.5912 14.1608 12.3983C14.1608 11.2053 13.1938 10.2383 12.0008 10.2383C10.8079 10.2383 9.84082 11.2053 9.84082 12.3983C9.84082 13.5912 10.8079 14.5583 12.0008 14.5583Z",
              fill: "#A5A7AF"
            }, null, -1),
            _createElementVNode("path", {
              d: "M18.4803 14.5583C19.6732 14.5583 20.6403 13.5912 20.6403 12.3983C20.6403 11.2053 19.6732 10.2383 18.4803 10.2383C17.2874 10.2383 16.3203 11.2053 16.3203 12.3983C16.3203 13.5912 17.2874 14.5583 18.4803 14.5583Z",
              fill: "#A5A7AF"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "flex flex-col pl-12",
      id: 'comment' + __props.review.id
    }, [
      _createElementVNode("div", {
        class: "flex flex-col space-y-5 p-4 pt-0 text-lg text-white pb-4 post-content",
        innerHTML: sanitizeHtml(__props.review.text)
      }, null, 8, _hoisted_11),
      (__props.review.edited_at)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Edited"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_10)
  ]))
}
}

})